import { AbCarousel } from "../../widgets/carousel/carousel.widget.js";
import { AbBrandImage } from "../brand-image/brand-image.component.js";
import { AbGrid } from "../../widgets/grid/grid.widget.js";
import { AbText } from "../../widgets/text/text.widget.js";
import { i18n } from "../../domain/i18n.js";
import { BaseComponent } from "../../base.component.js";

/**
 * @typedef {RenderableProps} _AbBadgeCarousel_Props
 * @property {_BrandPartner[]} brands
 * @property {'xs'|'md'|'lg'} size
 * @property {boolean} showTopText
 * @property {boolean} showBottomText
 * @property {string} t0
 */

export class AbBadgeCarousel extends BaseComponent {

  /**
   * @param {_AbBrandImage_Props} props
   */
  constructor(props) {
    super(props);
    this.state = {};
  }

  /**
   * Computes brand slides appropriate for a grid implementation
   * @private
   * @param {_BrandPartner[]} brands
   * @param {_GridSize} gridSize
   * @returns {{brands: _BrandPartner[]}[]}
   */
  _getBrandSlides(brands, gridSize) {
    const maxBrandsPerSlide = gridSize.x * gridSize.y;
    return brands.reduce((slides, brand) => {
      if (slides[slides.length - 1].brands.length < maxBrandsPerSlide) {
        // add brand to slide
        slides[slides.length - 1].brands.push(brand);
      } else {
        // new slide for this brand
        slides.push({ brands: [brand] });
      }
      return slides;
    }, [{ brands: [] }]);
  }

  /**
   * @param {_AbBadgeCarousel_Props} props
   * @param {object} state
   * @param {_AbComponent_Context} ctx
   * @returns {ComponentChild}
   */
  render = (props, state, ctx) => {
    if (props.size === 'lg' || props.size === 'md') {
      // grid variant
      let gridSize;
      if (props.size === 'md') {
        gridSize = { x: 2, y: 1 };
      } else if (props.size === 'lg') {
        gridSize = { x: 2, y: 2 };
      }
      const slides = this._getBrandSlides(props.brands, gridSize);

      return (
        <div className={`ab-badge-carousel ab-size-${props.size}`}>
          {props.showTopText &&
            <div className="ab-top-text">
              <AbText text={i18n.generic.authorizedBy} />
            </div>
          }

          {props.t0 &&
            <div className="t0-message">
              <AbText text={i18n.contents.texts.t0Message} />
            </div>
          }

          <AbCarousel>
            {slides.map(slide =>
              <AbGrid size={gridSize}>
                {slide.brands.map(brand =>
                  <AbBrandImage brand={brand} />
                )}
              </AbGrid>
            )}
          </AbCarousel>
          {props.showBottomText &&
            <div className="ab-bottom-text">
              <AbText text={i18n.contents.texts.tuvMember} />
            </div>
          }
        </div>
      );
    } else if (props.size === 'xs') {
      // simple variant
      return (
        <div className={`ab-badge-carousel ab-size-xs ${props.brands.length === 1 ? 'ab-single-brand' : ''}`}>
          <AbCarousel>
            {props.brands.map(brand =>
              <AbBrandImage brand={brand} />
            )}
          </AbCarousel>
        </div>
      );
    }
  };

}
